const MAP_ROOT = '/map';
const PRICING_ROOT = '/plans';
const PAYMENT_ROOT = '/payment';
const MY_PAGE_ROOT = '/mypage';

export const LG_UPLUS_PATH = '/uplus-map';

export const paths = {
  home: '/',
  intro: '/intro',
  signin: '/signin',
  welcome: '/welcome',
  pricing_root: PRICING_ROOT,
  payments_root: PAYMENT_ROOT,
  mypage_root: MY_PAGE_ROOT,
  mypage_account: `${MY_PAGE_ROOT}/personal-info`,
  mypage_pay: `${MY_PAGE_ROOT}/payment-info`,
  payments_process: `${PAYMENT_ROOT}/:transaction/:status/:type?`,
  map_root: MAP_ROOT,
  map_segment: `${MAP_ROOT}/:menu?/:id?`,
};

export const CHANNEL_TALK = 'https://myfranchise.channel.io/home';
export const NOTICE =
  'https://myfranchise.notion.site/1079a0c9c42a80579016d20e8ce54064?pvs=4';
export const SERVICE_GUIDE =
  'https://myfranchise.notion.site/1099a0c9c42a8030b001cb7af5c1e30a?pvs=4';

export const POLICY_LINKS = {
  policy:
    'https://myfranchise.notion.site/1079a0c9c42a80daa123f171b45edc3b?pvs=4',
  paid: 'https://myfranchise.notion.site/3429a0c9c42a80b3bbebc115e66f9a09',
  private:
    'https://myfranchise.notion.site/f2f4df59f883463ca814c50b538a3511?pvs=4',
  marketing:
    'https://myfranchise.notion.site/687094343fb34880b0c9b9445c42b965?pvs=4',
};

export const HOSTNAME = 'map.myfranchise.kr';
export const SITE_URL = 'https://' + HOSTNAME;

export const IS_LOCALHOST = window.location.host.includes('localhost');
export const IS_DEV_SERVER =
  IS_LOCALHOST || window.location.host.includes('dev-map.');
